'use client';

import { useTranslations } from 'next-intl';
import DocumentPageShell from '@/components/sections/shared/DocumentPageShell';
import PolicyPageContent from '@/components/sections/shared/PolicyPageContent';
import type { PrivacyPolicyData } from '@/types/privacy-policy';

interface PrivacyPolicyProps {
  locale: string;
  data: PrivacyPolicyData | null;
}

export default function PrivacyPolicy({ locale, data }: PrivacyPolicyProps) {
  const t = useTranslations('privacyPolicy');

  if (!data) {
    return (
      <DocumentPageShell title={t('error.title')}>
        <div className="rounded-2xl border border-[#e4e4e4] bg-white p-8 text-center shadow-sm">
          <p className="text-base text-[#737373]">{t('error.message')}</p>
        </div>
      </DocumentPageShell>
    );
  }

  return (
    <PolicyPageContent locale={locale} data={data} effectiveDateLabel={t('effectiveDateLabel')} />
  );
}
